import bsn from 'libraries/bootstrap-native.js';

import events from 'events.js';

function generateWidgetCode() {
    let listName;
    const elem = document.querySelector('[name="2"]:checked');
    const type = elem && elem.dataset.type;
    const typeId = elem && elem.value;
    if (type === 'community') {
        listName = 'communities';
    }
    if (type === 'association') {
        listName = 'associations';
    }
    if (type === 'user') {
        listName = 'user-ids';
    }
    if (type === 'all') {
        listName = 'all';
    }
    const valueSelect = document.querySelector(
        '.dropdown-' + typeId + ' select',
    );
    const valueOption =
        valueSelect && valueSelect.querySelector('option:checked');
    const value = valueOption && valueOption.value;
    const name = valueOption && valueOption.innerText;
    const url = valueOption && valueOption.dataset.url;
    const size = document.querySelector('[name="1"]:checked').id;
    const color = document.querySelector('[name="0"]:checked').value;
    let html = document.getElementById('template').innerHTML;
    html = html.replace('@URL@', url);
    html = html.replace('@NAME@', name);
    html = html.replace('@TYPE@', listName);
    html = html.replace('@VALUE@', value);
    html = html.replace('@SIZE@', size);
    html = html.replace('@COLOR@', color);
    html = html.replace(/data-script/g, 'script');
    html = html.replace('data-id', 'id');
    return html;
}

(async function() {
    await events.ready();

    events.listen(document.getElementById('preview-button'), 'click', function(
        e,
    ) {
        e.preventDefault();
        new bsn.Modal(document.getElementById('preview')).show();
    });
    events.listen(document.getElementById('code-button'), 'click', function(
        e,
    ) {
        e.preventDefault();
        new bsn.Modal(document.getElementById('copy')).show();
    });

    let elems = document.querySelectorAll(
        '.dropdown-1, .dropdown-2, .dropdown-3, .dropdown-4, .dropdown-5, .dropdown-6',
    );
    for (let elem of elems) {
        elem.style.display = 'none';
    }

    elems = document.querySelectorAll('[name="2"]');
    for (let elem of elems) {
        events.listen(elem, 'click', function(e) {
            elem.checked = 'checked';
            const active = Array.from(
                document.getElementsByClassName('active'),
            );
            for (let elem of active) {
                elem.style.display = 'none';
            }
            const dropDown = document.getElementsByClassName(
                'dropdown-' + elem.value,
            )[0];
            if (dropDown) {
                const select = dropDown.querySelector('select');
                if (select && select.querySelectorAll('option').length > 1) {
                    dropDown.style.display = 'block';
                    select.style.display = 'block';
                    select.classList.add('active');
                }
            }
        });
    }

    events.trigger(document.querySelectorAll('[name="2"]')[0], 'click');

    const copy = document.getElementById('copy');
    events.listen(copy, 'show.bs.modal', function(e) {
        const html = generateWidgetCode();
        document.getElementById('widget-copy').innerText = html;
    });

    const preview = document.getElementById('preview');
    events.listen(preview, 'show.bs.modal', function(e) {
        const html = generateWidgetCode();
        const width = document.querySelector('[name="1"]:checked').dataset
            .width;
        const adjWidth = Number(width) + Number(60) + 'px';
        document.querySelector(
            '#preview > .modal-dialog',
        ).style.width = adjWidth;
        const widgetPreview = document.getElementById('widget-preview');
        widgetPreview.innerHTML = html;
        const d = document.createElement('div');
        d.innerHTML = html;
        const scripts = d.firstChild.querySelectorAll('script');
        for (let sc of scripts) {
            const news = document.createElement('script');
            news.innerText = sc.innerText;
            if (sc.src) {
                news.src = sc.src;
            }
            news.type = 'text/javascript';
            document.getElementById('healthshare-widget').appendChild(news);
        }
    });

    const focus = document.getElementsByClassName('focus')[0];
    if (focus) {
        events.listen(focus, 'click', function() {
            document.querySelector(
                "'input:radio[id='" + focus.id + "']",
            ).checked = true;
        });
    }

    const showTerms = document.getElementsByClassName('show-terms')[0];
    events.listen(showTerms, 'click', function() {
        const it = document.getElementsByClassName('inline-terms')[0];
        it.style.display = it.style.display === 'block' ? 'none' : 'block';
    });
})();
